import React, { FC } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { formatNum } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { useOfferDetailModel } from '../offerDetailModel';
import { IOfferDetailsAdded } from '../../../offerTypes';

//加收费用
export const TableBoxAdded: FC<RouterParamType> = ({ id, mode }) => {
    const {
        editAddedList,
        setAddAddedList,
        addAddedList,
        setEditAddedList,
        addAdded,
        editDesc,
        addDesc,
        getcurrencySymbol,
        isDisabeld
    } = useOfferDetailModel(({ editAddedList, addAddedList, editDesc, editFormVal }) => [editAddedList, addAddedList, editDesc, editFormVal]);
    const addedList = mode === "edit" ? editAddedList : addAddedList;
    const setAddedList = mode === "edit" ? setEditAddedList : setAddAddedList;
    const desc = mode === "edit" ? editDesc : addDesc;


    const columns = [
        {
            title: '操作',
            width: 80,
            fixed: "left",
            align: "center",
            className: "td-wrap",
            render: (text: any, record: any, i: number) =>
                record.key === "totalAmount" ?
                    "" : <>
                        <YhBut
                            type="add"
                            txt="添加"
                            click={() => addAdded(mode)}
                        />
                        <YhBut
                            type="delete"
                            txt="删除"
                            disabled={addedList.length <= 1}
                            click={() => setAddedList(origin => origin.filter(item => item.key !== record.key))}
                        />
                    </>
        },
        {
            title: '序号',
            width: 50,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '费用名称(英文)',
            width: 160,
            dataIndex: 'ename',
            editable: true,
        }, {
            title: '费用名称(中文)',
            width: 160,
            dataIndex: 'name',
            editable: true,
        }, {
            title: '金额',
            width: 160,
            dataIndex: 'amount',
            editable: true,
            render: (text: any) => `${getcurrencySymbol(mode)} ${formatNum(text)}`,
        }
    ];

    const newColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: IOfferDetailsAdded, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑
                editable: record.key === "totalAmount" ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: IOfferDetailsAdded) => {
        row.amount = formatNum(row.amount);
        let dataSource = [...addedList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setAddedList(dataSource);
    }




    const totalRow = {
        key: "totalAmount",
        totalTxt: "合计:",
        amount: desc.addedAmountAll,
    }
    return (
        <YhBox title="加收费用" style={{ marginBottom: "10px", width: "100%" }}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                // components={{
                //     body: {
                //         row: EditableRow,
                //         cell: EditableCell,
                //     },
                // }}
                // columns={newColumns as ColumnsType<IOfferDetailsAdded>}
                components={isDisabeld(mode)
                    ? {} : {
                        body: {
                            row: EditableRow,
                            cell: EditableCell,
                        },
                    }}
                columns={(isDisabeld(mode) ? columns.splice(1, columns.length - 1) : newColumns) as ColumnsType<IOfferDetailsAdded>}
                dataSource={addedList.length > 0 ? [...addedList, totalRow] : []}
                pagination={false}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    )
}